<template>
  <v-sheet
      ref="sheet"
      :height="height"
      class="overflow-y-auto"
  >
    <div v-if="chatDatasLoading"></div>
    <div v-else-if="chats.length===0">
      <alert>Не найдено</alert>
    </div>
    <v-list v-else class="pa-0" dense>
      <v-list-item
          v-for="d in chats" :key="d.id"
          :class="(localSelectChat?.id===d.id ? 'v-list-item--active' : '')+(d.blink===true ? ' blinkWarning' : '')"
          class="pa-0"
          @click="localSelectChat=d"
      >
        <v-row class="full-width" no-gutters>
          <v-col class="pa-3">
            <v-row no-gutters>
              <v-col>{{ d._name }}</v-col>
              <v-col class="caption" cols="auto">
                {{ d.dialogMesLast == null ? '' : $tools.dateFormat(d.dialogMesLast.created, true) }}
              </v-col>
            </v-row>
            <v-row align="center" no-gutters>
              <v-col class="body-2 text-no-wrap overflow-hidden text-overflow muted1" style="flex:1">
                <span v-if="d.dialogMesLast===null" class="body-2 text-no-wrap overflow-hidden muted">
                  Нет сообщений
                </span>
                <span v-else>
                  <span v-if="d.dialogMesLast.type==='event'" class="muted1">
                    {{d.dialogMesLast.text}}
                  </span>
                  <span v-if="d.dialogMesLast.type==='message'">
                    <span>{{ d.dialogMesLast.dialogUser.name}}:</span>
                    <span style="flex:1">{{ d.dialogMesLast.text }}</span>
                    <span v-if="d.dialogMesLast.dialogMessageAttachs.length>0">(Вложение)</span>
                  </span>
                </span>
              </v-col>
              <v-col class="pl-2" cols="auto">
                <v-sheet v-if="d._unreadCount>0" color="transparent" height="20" width="20">
                  <v-avatar class="caption white--text position-absolute" color="primary" size="20">
                    {{ d._unreadCount }}
                  </v-avatar>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col v-if="operator(d)!==null" cols="auto" class="mr-2">
                <chip class="mt-1" small>
                  <v-row no-gutters align="center">
                    <v-col cols="auto">
                      <v-icon class="mr-1" style="margin-top:-2px" small>mdi-account-tie</v-icon>
                    </v-col>
                    <v-col>{{ $tools.userFullName(operator(d), true) }}</v-col>
                  </v-row>
                </chip>
              </v-col>
              <v-col v-if="d.cat!=='internal'" cols="auto">
                <chip class="mt-1" small>
                  <v-row no-gutters class="text-left">
                    <v-col cols="auto">
                      <v-icon class="mr-1" style="margin-top:-2px" small>mdi-account-badge</v-icon>
                    </v-col>
                    <v-col>
                      <div v-if="d.callTarget==null">Не указана цель обращения</div>
                      <div v-else>
                        {{ d.callTarget.name }}
                        <div v-if="d.callResult!==null" class="d-inline-block">
                          <dot/>
                          <v-avatar v-if="d.callResult.type==='success'" color="success" size="12" class="mr-1"
                                    style="margin-top:-2px">
                            <v-icon color="white" size="10">mdi-check</v-icon>
                          </v-avatar>
                          <v-avatar v-else-if="d.callResult.type==='info'" color="blue" size="12" class="mr-1"
                                    style="margin-top:-2px">
                            <v-icon color="white" size="14">mdi-information-symbol</v-icon>
                          </v-avatar>
                          <v-avatar v-else color="red" size="12" class="mr-1" style="margin-top:-2px">
                            <v-icon color="white" size="8">mdi-close</v-icon>
                          </v-avatar>
                          {{ d.callResult.name }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </chip>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider/>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
import Alert from "@/componentsV2/base/Alert.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import axios from "axios";
import Dot from "../../../../componentsV2/base/Dot.vue";

export default {
  components: {Dot, Chip, Alert},
  props: ['height', 'cat', 'search', 'filterView', 'selectChat', 'onlyMyChats'],
  data: () => ({
    chatDatas: [],
    chats: [],
    chatDatasLoading: false,
    localSelectChat: null,
    subscribeListenerId: null,
  }),
  mounted() {
    this.localSelectChat = this.selectChat;
    this.load();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v) => this.subscribeListenerId = v, (m) => {
      if (m.type === 'dialogChat') {
        if (m.data.cat === 'internal' && !m.data.dialogUsers?.some(v => v.user?.id === this.$store.state.user?.id)) {
          const index = this.chatDatas.findIndex(v => v.id === m.data.id);
          if (index !== -1)
            this.chatDatas.splice(index, 1);
          if (this.localSelectChat?.id === m.data.id)
            this.localSelectChat = null;
          this.chatsFilter();
          return;
        }
        this.dialogChatEvent(m.data, true);
      }
      if (m.type === 'dialogChatUnread') this.dialogChatUnreadEvent(m.data);
    });
  },
  watch: {
    filterView() {
      this.chatsFilter()
    },
    search() {
      this.load()
    },
    selectChat() {
      this.localSelectChat = this.selectChat
    },
    localSelectChat() {
      this.$emit('update:selectChat', this.localSelectChat)
    },
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
  },
  methods: {
    load() {
      this.chatDatas = [];
      this.$emit('loading', true);
      this.chatDatasLoading = true;

      let params = [];
      if (this.cat) params.push('cat=' + this.cat.id)
      if (!this.$tools.isEmpty(this.search)) params.push('q=' + this.search)

      axios.get('/napi/dialog/chat/?' + params.join('&'))
          .then(r => {
            if (!this.$tools.isEmpty(this.search)) {
              this.chats = r.data;
              this.chatsSort();
              this.$emit('loading', false);
              this.chatDatasLoading = false;
              return;
            }

            r.data.forEach(v => this.dialogChatEvent(v))
            this.$emit('loading', false);
            this.chatDatasLoading = false;
          });
    },
    dialogChatEvent(data, isEvent = false) {
      const index = this.chatDatas.findIndex(v => v.id === data.id);

      data.blink = isEvent;

      if (index === -1) this.chatDatas.push(data);
      else this.chatDatas[index] = data;

      if (isEvent)
        setTimeout(() => {
          const index = this.chatDatas.findIndex(v => v.id === data.id);
          if (index !== -1) {
            this.chatDatas[index].blink = false;
            this.chatsFilter();
          }
        }, 2000)

      this.chatsFilter();
    },
    dialogChatUnreadEvent(data) {
      const index = this.chatDatas.findIndex(v => v.id === data.id);
      if (index === -1) return;
      this.chatDatas[index]._unreadCount = data.count;
      this.chatsSort();
    },
    chatsFilter() {
      if (this.$tools.isDefined(this.onlyMyChats) || (this.cat?.id === 'process' && this.filterView?.id === 'my')) {
        const userId = this.$store.state.user?.id;
        this.chats = this.chatDatas.filter(chat =>
            chat.dialogUsers?.some(dialogUser => dialogUser.user?.id === userId)
        );
      } else {
        this.chats = this.chatDatas;
      }

      if (this.cat)
        this.chats = this.chats.filter(v => v.cat === this.cat.id)

      this.chatsSort();
    },

    chatsSort() {
      this.chats = this.chats.sort((a, b) => {
        let a1 = a.dialogMesLast ? 10000 + a.dialogMesLast.id : +a.id;
        let b1 = b.dialogMesLast ? 10000 + b.dialogMesLast.id : +b.id;
        if (a1 === b1) return 0;
        return a1 > b1 ? -1 : 1;
      })

      if (this.cat)
        this.$emit('unreadCount', this.chats.filter(chat => chat.cat === this.cat.id && chat._unreadCount > 0).length);
    },

    operator(d){
      if (this.cat?.id === 'internal') return null;
      if(this.filterView?.id!=='all') return null;
      let arr = d.dialogUsers.filter(v=>v.user?.type!=='client')
      if(arr.length>0) return arr[0].user;
      return null;
    }
  }
}
</script>